import React, { useState, useContext, useEffect} from "react";
import { store } from "../context/store";
import Header from "../components/Header";
import LeftMenu from "../components/LeftMenu";
import ResourcesDirectory from "../components/ResourcesDirectory";
import {functions} from "../constants/common-functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {FORGE_VIEWER_TYPE_NO_PANEL} from "../constants/general-constants";
import {UNSET} from "../constants/general-constants";

import {
  faChevronRight,
  faSearch,
  faFilePdf,
  faFile,
  faFileWord,
  faFileExcel,
  faCamera
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";

/* ======================================================
   COMPONENT
   ====================================================== */

export default function Resources({onOpenForge}) {

  
	
  const globalState = useContext(store);
  const { id } = useParams();
  
  const [iframeOpen, setIframeOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");

  /* ======================================================
     STATE – LOOKUPS
     ====================================================== */

  const [directories, setDirectories] = useState([]);
  const [resourceTypes, setResourceTypes] = useState([]);
  const [revisions, setRevisions] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [floors, setFloors] = useState([]);

  /* ======================================================
     STATE – FILTERS
     ====================================================== */

  const [selectedDirectoryId, setSelectedDirectoryId] = useState("0");
  const [selectedResourceTypeId, setSelectedResourceTypeId] = useState(
    id && id !== UNSET ? id : "0"
  );
  const [selectedRevisionId, setSelectedRevisionId] = useState("0");
  const [selectedFacilityId, setSelectedFacilityId] = useState(UNSET);
  const [selectedFloorId, setSelectedFloorId] = useState("0");
  const [searchText, setSearchText] = useState("");

  /* ======================================================
     STATE – RESULTS
     ====================================================== */

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ======================================================
     LOAD LOOKUPS (ONCE)
     ====================================================== */

  useEffect(function () {
	functions.getArrayFromAjax("/resolutionsoftwareplatform/resources/directories",setDirectories, null);
	functions.getArrayFromAjax("/resolutionsoftwareplatform/resources/resourcetypes",setResourceTypes, null);
	functions.getArrayFromAjax("/resolutionsoftwareplatform/resources/revisions",setRevisions, null);
	functions.getArrayFromAjax("/resolutionsoftwareplatform/resources/buildings",setFacilities, null);
  }, []);

  /* ======================================================
     LOAD FLOORS WHEN BUILDING CHANGES
     ====================================================== */
	 
 

  useEffect(function () {

    if (selectedFacilityId === UNSET) {
      setFloors([]);
      setSelectedFloorId("0");
      return;
    }
	functions.getArrayFromAjax("/resolutionsoftwareplatform/resources/floors?buildingId=" + selectedFacilityId, setFloors, null);

  }, [selectedFacilityId]);
  
  const setFiles = (obj) => {
	console.log(obj);
  }
  
  
  function openIframe(url) {
    setIframeUrl(url);
    setIframeOpen(true);
  }

  function closeIframe() {
    setIframeOpen(false);
    setIframeUrl("");
  }
  
  function getResourceIcon(data) {

    if (data.filename) {

      const name = data.filename.toLowerCase();

      if (name.endsWith(".pdf")) return faFilePdf;
      if (name.endsWith(".doc") || name.endsWith(".docx")) return faFileWord;
      if (name.endsWith(".xls") || name.endsWith(".xlsx")) return faFileExcel;

      return faFile;
    }

    return faCamera;
  }

  function openResource(data) {
	
    if (data.urn) {
      onOpenForge({
        urn: data.urn,
        title: data.name || data.description,
        mode: FORGE_VIEWER_TYPE_NO_PANEL
      });
      return;
    }

    if (data.url || data.filename) {
      openIframe(data.url || data.filename);
    }
  }


  /* ======================================================
     LOAD RESOURCES
     ====================================================== */

  function loadResources() {

    setLoading(true);

    const params = new URLSearchParams();

    if (selectedDirectoryId !== "0") {
      params.append("directoryId", selectedDirectoryId);
    }

    if (selectedResourceTypeId !== "0") {
      params.append("documentType", selectedResourceTypeId);
    }

    if (selectedRevisionId !== "0") {
      params.append("revision", selectedRevisionId);
    }

    if (selectedFacilityId !== UNSET) {
      params.append("buildingId", selectedFacilityId);
    }

    if (selectedFloorId !== "0") {
      params.append("floorId", selectedFloorId);
    }

    if (searchText.trim().length > 0) {
      params.append("search", searchText.trim());
    }
	

	functions.getArrayFromAjax("/resolutionsoftwareplatform/resources/resources?" + params.toString(), setResults, setLoaded);
  }

  const setLoaded = (results) => {
	
	setLoading(false);
  }
  
  /* ======================================================
     RELOAD ON FILTER CHANGE
     ====================================================== */

  useEffect(function () {
    loadResources();
  }, [
    selectedDirectoryId,
    selectedResourceTypeId,
    selectedRevisionId,
    selectedFacilityId,
    selectedFloorId
  ]);

  /* ======================================================
     SEARCH DEBOUNCE
     ====================================================== */

  useEffect(function () {

    const t = setTimeout(function () {
      loadResources();
    }, 300);

    return function () {
      clearTimeout(t);
    };

  }, [searchText]);

  /* ======================================================
     AUTH HELPER
     ====================================================== */


  /* ======================================================
     STYLES (UNCHANGED)
     ====================================================== */

  const container = {
    display: "flex",
    position: "fixed",
    width: "100%",
    height: "100vh",
    left: 0,
    top: 0,
    background: "linear-gradient(180deg,#ffffff 0%,#f4f6fb 100%)"
  };

  const content = {
    display: "flex",
    width: "calc(100% - 60px)",
    marginLeft: "60px",
    marginTop: "60px",
    height: "calc(100vh - 60px)"
  };

  const directoryPanel = {
    width: "260px",
    background: "linear-gradient(180deg,#2b2f34 0%,#16181c 100%)",
    color: "white",
    padding: "20px",
    margin: "20px 0",
    borderTopRightRadius: "13px",
    borderBottomRightRadius: "13px",
    boxShadow: "0 10px 24px rgba(0,0,0,0.35)"
  };

  const mainPanel = {
    flex: 1,
    padding: "24px",
    overflow: "auto"
  };

  const select = {
    width: "180px",
    padding: "8px 10px",
    borderRadius: "8px",
    border: "1px solid rgba(0,0,0,0.15)"
  };

  const searchInput = {
    flex: 1,
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(0,0,0,0.15)"
  };

  const resultRow = {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    borderRadius: "12px",
    background: "white",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
	marginTop:'10px'
  };
  
  function rowStyle(hover) {
    return {
      display: "flex",
      alignItems: "center",
      padding: "16px",
      borderRadius: "12px",
      background: hover ? "#f7f9ff" : "white",
      cursor: "pointer",
      boxShadow: hover
        ? "0 8px 20px rgba(60,80,180,0.18)"
        : "0 4px 10px rgba(0,0,0,0.06)",
      transform: hover ? "translateY(-1px)" : "translateY(0)",
      transition: "all 180ms ease",
      marginTop: "10px"
    };
  };
  
  function chevronStyle(hover) {
    return {
      color: hover ? "#3c50b4" : "#999",
      transform: hover ? "translateX(4px)" : "translateX(0)",
      transition: "all 180ms ease"
    };
  }



  /* ======================================================
     RESULT ROW
     ====================================================== */

	 function ResultRow({ data }) {

	   const [hover, setHover] = useState(false);

	   return (
		<div
		  style={rowStyle(hover)}
		  onMouseEnter={() => setHover(true)}
		  onMouseLeave={() => setHover(false)}
		  onClick={() => openResource(data)}
		>
	       <FontAwesomeIcon
	         icon={getResourceIcon(data)}
	         style={{ color: "#4285F4", width: "26px", height: "26px" }}
	       />

	       <div style={{ flex: 1, marginLeft: "16px" }}>
	         <div style={{ fontWeight: 600 }}>
	           {data.name || data.description}
	         </div>

	         <div style={{ fontSize: "13px", color: "#666" }}>
	           {data.author} · {data.docDate} · {data.resourceRevisionId}
	         </div>
	       </div>

	       <FontAwesomeIcon icon={faChevronRight} style={chevronStyle(hover)} />
	     </div>
	   );
	 }



  /* ======================================================
     RENDER
     ====================================================== */

  return (
    <div style={container}>
      <Header />
      <LeftMenu />

      <div style={content}>

        {/* DIRECTORY */}
        <div style={directoryPanel}>
          <h3>Documents</h3>
          {directories.map(function (d) {
            return (
              <ResourcesDirectory
                key={d.id}
                id={d.id}
                name={d.name}
                selectedDirectoryId={selectedDirectoryId}
                setSelectedDirectoryIdFunction={setSelectedDirectoryId}
				setFilesFunction={setFiles}
              />
            );
          })}
        </div>

        {/* MAIN */}
        <div style={mainPanel}>

          {/* FILTERS */}
          <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
		  <select
		    style={select}
		    value={selectedResourceTypeId}
		    onChange={e => setSelectedResourceTypeId(e.target.value)}
		  >
		    <option value="0">All</option>
		    {resourceTypes.map(t => (
		      <option key={t.id} value={t.id.toString()}>
		        {t.name}
		      </option>
		    ))}
		  </select>


            <select style={select} onChange={e => setSelectedRevisionId(e.target.value)}>
              <option value="0">All</option>
              {revisions.map(r => (
                <option key={r.id} value={r.id}>{r.name}</option>
              ))}
            </select>

            <select style={select} onChange={e => setSelectedFacilityId(parseInt(e.target.value, 10))}>
              <option value={-100}>All</option>
              {facilities.map(f => (
                <option key={f.id} value={f.id}>{f.name}</option>
              ))}
            </select>

            <select style={select} onChange={e => setSelectedFloorId(e.target.value)}>
              <option value="0">All</option>
              {floors.map(fl => (
                <option key={fl.id} value={fl.id}>{fl.name}</option>
              ))}
            </select>

            <input
              style={searchInput}
              placeholder="Search documents…"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
            />

            <FontAwesomeIcon icon={faSearch} />
          </div>

          {/* RESULTS */}
          {loading && <div>Loading documents…</div>}

          {!loading && results.map(r => (
            <ResultRow key={r.id} data={r} />
          ))}

        </div>
      </div>
	  {iframeOpen && (
	    <div
	      style={{
	        position: "fixed",
	        left: 0,
	        top: 0,
	        width: "100vw",
	        height: "100vh",
	        background: "rgba(0,0,0,0.6)",
	        zIndex: 9999999,
	        display: "flex",
	        alignItems: "center",
	        justifyContent: "center"
	      }}
	    >
	      <div
	        style={{
	          width: "90%",
	          height: "90%",
	          background: "white",
	          borderRadius: "14px",
	          overflow: "hidden",
	          boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
	          display: "flex",
	          flexDirection: "column"
	        }}
	      >
	        {/* Header */}
	        <div
	          style={{
	            padding: "10px 14px",
	            background: "#16181c",
	            color: "white",
	            display: "flex",
	            justifyContent: "space-between",
	            alignItems: "center"
	          }}
	        >
	          <div>Document Preview</div>
	          <div
	            style={{ cursor: "pointer", fontWeight: 600 }}
	            onClick={closeIframe}
	          >
	            ✕
	          </div>
	        </div>

	        {/* IFRAME */}
	        <iframe
	          src={iframeUrl}
	          title="Document Viewer"
	          style={{
	            flex: 1,
	            border: "none"
	          }}
	        />
	      </div>
	    </div>
	  )}

    </div>
  );
}
